export const SUB_HEADING_STYLE =
    " text-lg md:text-2xl	 font-medium	  font-Montserrat text-Heading_Black  ";
